import { ContentWrapper } from '../ui/content-wrapper/content-wrapper'
import { Footer } from '../ui/footer/footer'
import { ClientPortalPublicContent } from './ui/client-portal-public-content/client-portal-public-content'
import { ClientPortalPublicHeader } from './ui/client-portal-public-header/client-portal-public-header'
import { useClientPortalPublicPage } from './use-page'

export const ClientPortalPublicPage = () => {
  const { caseNumber } = useClientPortalPublicPage()

  return (
    <>
      <ContentWrapper>
        <ClientPortalPublicHeader caseNumber={caseNumber} />
        <ClientPortalPublicContent />
      </ContentWrapper>
      <Footer />
    </>
  )
}
